import React from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { uiActions } from "../store/ui/ui-slice";
import { getAxios } from "../Services/commonService";
import { API_DASHBOARD_COUNT } from "../utils/api/ApiConstant";
import { SubHeading } from "../Components";

const Dashboard = () => {
  const location = useLocation();
  const { heading } = location.state || {};
  const dispatch = useDispatch();

  if (heading) {
    dispatch(uiActions.setHeading(heading));
  }

  const { isLoading, data: dashboardCount } = useQuery({
    queryKey: ["dashboardCountData"],
    queryFn: async () => await getAxios(API_DASHBOARD_COUNT, {}),
  });

  return (
    <>
      <SubHeading subTitle="Today Matches Data" isAddBtn={false} />
      <div className="row m-0 mt-1 p-0">
        <div className="col-lg-6 m-0 p-1 text-center">
          <div className="p-2 border-dashed border-theme-color rounded">
            <p className="text-muted text-uppercase mb-0 fw-normal fs-13">
              Today Bookmaker
            </p>
            <h5 className="mt-1 mb-0 fw-medium text-success">
              {dashboardCount?.bookmakerCount}
            </h5>
          </div>
        </div>
        <div className="col-lg-6 m-0 p-1 text-center">
          <div className="p-2 border-dashed border-theme-color rounded">
            <p className="text-muted text-uppercase mb-0 fw-normal fs-13">
              Today Fancy
            </p>
            <h5 className="mt-1 mb-0 fw-medium text-success">
              {dashboardCount?.fancyCount}
            </h5>
          </div>
        </div>
      </div>
      <div className="row card-body m-0 mt-2 p-0">
        <div className="col-md-6 col-lg-4 ">
          <div className="card position-relative">
            <div className="card-header ">
              <div className="row align-items-center">
                <div className="col">
                  <h4 className="card-title">Cricket</h4>
                </div>
              </div>
            </div>
            <div className="card-body pt-0  ">
              <div className="table-responsive fix-container">
                <table className="table mb-0">
                  <tbody>
                    {dashboardCount?.matches
                      .filter((item) => item?.sport?.id == 4)
                      .map((item) => (
                        <tr key={item?._id} className="">
                          <td className="px-0">
                            <div className="d-flex align-items-center">
                              <Link
                                className="m-0 text-truncate"
                                to={`/eventmaster/market/${item?.id}`}
                              >
                                {item?.name}
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {/* <hr className="hr-dashed" /> */}
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-4 ">
          <div className="card">
            <div className="card-header">
              <div className="row align-items-center">
                <div className="col">
                  <h4 className="card-title">Soccer</h4>
                </div>
              </div>
            </div>
            <div className="card-body pt-0">
              <div className="table-responsive fix-container">
                <table className="table mb-0">
                  <tbody>
                    {dashboardCount?.matches
                      .filter((item) => item?.sport?.id == 1)
                      .map((item) => (
                        <tr key={item?._id} className="">
                          <td className="px-0">
                            <div className="d-flex align-items-center">
                              <Link
                                className="m-0 text-truncate"
                                to={`/eventmaster/market/${item?.id}`}
                              >
                                {item?.name}
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {/* <hr className="hr-dashed" /> */}
            </div>
          </div>
        </div>

        <div className="col-md-6 col-lg-4 ">
          <div className="card ">
            <div className="card-header">
              <div className="row align-items-center">
                <div className="col">
                  <h4 className="card-title">Tennis</h4>
                </div>
              </div>
            </div>
            <div className="card-body pt-0">
              <div className="table-responsive fix-container">
                <table className="table mb-0">
                  <tbody>
                    {dashboardCount?.matches
                      .filter((item) => item?.sport?.id == 2)
                      .map((item) => (
                        <tr key={item?._id} className="">
                          <td className="px-0">
                            <div className="d-flex align-items-center">
                              <Link
                                className="m-0 text-truncate"
                                to={`/eventmaster/market/${item?.id}`}
                              >
                                {item?.name}
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              {/* <hr className="hr-dashed" /> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
